export const blockToSkipOverviewUpdate = ["total_spend", "ads_cost", "days_reporting"];

export const currencyBlocks = [
    "total_spend", 
    "ads_cost", 
    "agency_cost", 
    "spend",
    "cpm",
    "custom_cost_clicks_all",
    "custom_cost_link_clicks",
    "custom_cost_page_engagements",
    "custom_cost_3_second_video_plays",
    "cost_per_thruplay",
    "custom_cost_landing_page_views",
    "custom_cost_website_add_to_cart",
    "custom_cost_website_content_views",
    "custom_cost_initiate_checkout",
    "custom_cost_website_purchases",
    "custom_cost_website_leads",
    "custom_cost_website_complete_registration",
    "custom_cost_contact",
    "custom_cost_schedule_total",
    "custom_cost_start_trial",
];